import React, { useState } from 'react';
import cx from 'classnames';
import styles from './CustomCalendarToolbar.module.scss';
import Icon from 'engage/components/Icon/Icon';
import { useTranslation } from 'react-i18next';
import { CustomButton } from 'engage/components/Button/Button';
import SyncWithCalendarContent from '../SyncWithCalendarContent/SyncWithCalendarContent';
import Modal from 'engage/components/Modal';

export let navigate = {
    PREVIOUS: 'PREV',
    NEXT: 'NEXT',
    TODAY: 'TODAY',
    DATE: 'DATE',
}

const ViewNamesGroup = ({ views: viewNames, view, messages, onView }) => {
    return viewNames.map((name) => (
        <CustomButton
            key={name}
            variant={'link'}
            onClick={() => onView(name)}
            label={messages[name]}
            className={cx(styles.button, styles.viewBtn, { [styles.active]: view === name })}
            aria-label={messages[name]}

        />
    ))
}

const CustomCalendarToolbar = ({
    date,
    label,
    localizer: { messages },
    onNavigate,
    onView,
    view,
    views, }) => {
    const { t } = useTranslation();

    const [isSyncModal, setIsSyncModal] = useState(false);

    return (
        <div className={styles.wrapper}>
            <div className={styles.viewGroup}>
                <ViewNamesGroup
                    view={view}
                    views={views}
                    messages={messages}
                    onView={onView}
                />
            </div>

            <div className={styles.viewGroup} style={{ flexWrap: 'nowrap' }}>
                <CustomButton
                    variant='link'
                    onClick={() => onNavigate(navigate.PREVIOUS)}
                    aria-label={messages.previous}
                    className={styles.arrowBtn}
                >
                    <Icon src='chevronLeft' />
                </CustomButton>
                <span className={styles.label}>{label}</span>
                <CustomButton
                    variant='link'
                    onClick={() => onNavigate(navigate.NEXT)}
                    aria-label={messages.next}
                    className={styles.arrowBtn}
                >
                    <Icon src='chevronRight' />
                </CustomButton>
            </div>
            <CustomButton
                variant='link'
                label={messages.today}
                onClick={() => onNavigate(navigate.TODAY)}
                aria-label={messages.today}
                className={styles.button}
            />
            <CustomButton variant='link' label={t('schedule.calendar.sync')} onClick={() => setIsSyncModal(true)} />
            <Modal open={isSyncModal} onClose={() => setIsSyncModal(false)}>
                <SyncWithCalendarContent onClose={() => setIsSyncModal(false)} />
            </Modal>
        </div>
    )
}

export default CustomCalendarToolbar;